import { useState } from "react";
import useSessionStorage from "../../helpers/useSessionStorage";
import { jwtDecode } from "jwt-decode";
import { get_branch } from "../../services/branch.service";

export const UserState = () => {
  const [profile, setProfile] = useSessionStorage("@USER_DATA_MG", {});
  const [token, setToken] = useSessionStorage("@TOKEN_DATA_MG", "");
  const [branchData, setBranchData] = useSessionStorage("@BRANCH_DATA_MG", {});
  const [isLoadingDetailPage, setIsLoadingDetailPage] = useState(false); // loading page

  let logoutTimeout;

  // function
  const getBranchData = async (token) => {
    if (token) {
      const decodedToken = jwtDecode(token);
      if (!decodedToken?.branchId) return;
      console.log("decodedToken?.branchId", decodedToken?.branchId);
      console.log("token", token);
      const data = await get_branch(decodedToken?.branchId, token);
      setBranchData({
        _id: data?.data?.branchInfo?._id,
        branchName: data?.data?.branchInfo?.branchName,
        districtName: data?.data?.districtInfo?.districtName,
        provinceName: data?.data?.provinceInfo?.provinceName,
        branchNo:  data?.data?.branchInfo?.branchNo,
      });
    }
  };
  function logout() {
    setToken();
  }

  function manualLogout() {
    clearTimeout(logoutTimeout);
    logout();
  }
  function setAllToLogout(token) {
    if (!token) return;
    const decodedToken = jwtDecode(token);
    const expirationTime = decodedToken.exp * 1000;
    const currentTime = new Date().getTime();
    const timeoutDuration = expirationTime - currentTime;
    logoutTimeout = setTimeout(() => {
      logout();
    }, timeoutDuration);
  }
  // hook
  setAllToLogout(token);

  return {
    profile,
    setProfile,
    token,
    setToken,
    isLoadingDetailPage,
    setIsLoadingDetailPage,
    manualLogout,
    branchData,
    setBranchData,
    getBranchData,
  };
};
